import { createRouter, createWebHistory } from "vue-router";
import { Home } from "@/widgets";
import {
  AddressPage,
  TransactionPage,
  BlockPage,
  NotFound,
  InstantTransactionPage,
} from "@/pages";
import { i18n } from "@/app/plugins/i18n/VueI18n";
import { capitalize } from "@/shared/utils/format/string";
import * as Sentry from "@sentry/vue";

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
    meta: {
      title: "EMCD - Explorer",
    },
  },
  {
    path: "/:network/address/:id",
    name: "Address Details",
    component: AddressPage,
    meta: {
      title: "AddressesTitle",
      type: "address",
    },
  },
  {
    path: "/:network/new-block/:id",
    name: "New block Details",
    component: BlockPage,
    meta: {
      title: "New blockTitle",
      type: "block",
    },
  },
  {
    path: "/:network/transaction/:id",
    name: "Transaction Details",
    component: TransactionPage,
    meta: {
      title: "TransactionTitle",
      type: "transaction",
    },
  },
  {
    path: "/:network/transaction/instant/:payload",
    name: "Instant Transaction Details",
    component: InstantTransactionPage,
    meta: {
      title: "Instant Transaction",
      type: "instantTransaction",
    },
  },
  {
    path: "/:pathMatch(.*)*",
    name: "NotFound",
    component: NotFound,
    meta: {
      title: "NotFound | PageTitle",
      type: "notFound",
    },
  },
];

const router = createRouter({
  history: createWebHistory("/explorer"),
  routes,
  scrollBehavior() {
    // Always scroll up the page
    return { top: 0 };
  },
});

router.beforeEach((to) => {
  if (to.meta.title) {
    const { t } = i18n.global;

    if (to.params.id && to.meta.type) {
      // Get first 5 characters of hash/id
      const prefix = to.params.id.substring(0, 5);
      const type = to.meta.type;
      const network = capitalize(to.params.network || "");

      document.title = `${prefix} / ${network} / ${type} / EMCD explorer`;
    } else {
      document.title = t(to.meta.title, {
        network: capitalize(to.params.network || ""),
      });
    }
  }
});

router.onError((error) => {
  Sentry.captureException(error);
  console.error(error);
});

export { router };
